import script from "./registerAgree.vue?vue&type=script&setup=true&lang=js"
export * from "./registerAgree.vue?vue&type=script&setup=true&lang=js"

import "./registerAgree.vue?vue&type=style&index=0&id=14d7f6a6&lang=less"

const __exports__ = script;

export default __exports__